import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  QueryList,
  ElementRef,
  AfterViewInit
} from '@angular/core';

@Component({
    selector: 'pme-product-selector',
    templateUrl: './product-selector.component.html',
    styleUrls: ['./product-selector.component.scss'],
    standalone: false
})
export class ProductSelectorComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() titlesToggles: string[] = [];
  @Output() selectionChanged = new EventEmitter<number>();

  @ViewChild('toggleContainer', { static: true }) toggleContainer!: ElementRef;
  @ViewChild('highlight', { static: true }) highlightRef!: ElementRef;
  @ViewChildren('buttonRef') buttonRefs!: QueryList<ElementRef>;

  selectedIndex: number | null = null;

  constructor() {}

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['titlesToggles'] && this.titlesToggles?.length > 0 && this.selectedIndex === null) {
      setTimeout(() => this.selectTitle(0), 0);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.moveHighlight(), 0);
  }

  selectTitle(index: number): void {
    this.selectedIndex = index;
    this.selectionChanged.emit(index);
    this.moveHighlight();
  }

  moveHighlight(): void {
    if (this.selectedIndex === null) return;

    const buttons = this.buttonRefs.toArray();
    const highlightEl = this.highlightRef.nativeElement as HTMLElement;
    const targetButton = buttons[this.selectedIndex]?.nativeElement as HTMLElement;

    if (!targetButton) return;

    const containerLeft = this.toggleContainer.nativeElement.getBoundingClientRect().left;
    const buttonRect = targetButton.getBoundingClientRect();

    const offsetLeft = buttonRect.left - containerLeft;
    const width = buttonRect.width;

    highlightEl.style.left = `${offsetLeft}px`;
    highlightEl.style.width = `${width}px`;
  }
}
